<a
  href="#"
  (click)="handleClick($event)"
  >{{ 'shared:licenses.paymentMethod' | i18next }}</a
>
